import type { CommentsItemPeopleItemT } from '@root/src/types';
import { declension } from '@utils/declension';
import { twcls } from '@utils/twcls';
import dayjs from 'dayjs';
import { memo, type FC } from 'react';
import { userNoAvatar } from '@images';
import icons from '@icons';
import { Picture } from '@ui';
const { star2, speechBalloon } = icons.emoji;

interface ClientReviewStatsProps {
  peopleItem: CommentsItemPeopleItemT;
  openModal: () => void;
  withoutHover?: boolean;
  className?: string;
  withoutDateIcon?: boolean;
  isModalDisabled?: boolean;
  tooltipAlignRight?: boolean;
}

const ClientReviewStats: FC<ClientReviewStatsProps> = ({
  peopleItem,
  openModal,
  className,
  withoutHover = false,
  withoutDateIcon = false,
  isModalDisabled = false,
  tooltipAlignRight = false
}) => {
  const date = peopleItem.date
    ? dayjs(peopleItem.date as Date | string).format('YYYY')
    : '';
  const comments = `${peopleItem.totalReviews || 0} ${declension(
    peopleItem.totalReviews || 0,
    ['отзыв', 'отзыва', 'отзывов']
  )}`;
  return (
    <>
      <div
        onClick={isModalDisabled ? undefined : openModal}
        className={twcls(
          'relative flex items-center space-x-2 text-sm transition-colors cursor-default',
          !withoutHover && 'group  cursor-pointer',
          className
        )}
      >
        {date && (
          <div className='flex items-center text-[var(--ultra-dark-grey)] group-hover:text-[var(--dark-red)]'>
            {!withoutDateIcon && (
              <Picture
                pictureClassName={'mr-1'}
                icon={star2}
                width='14'
                height='14'
              />
            )}{' '}
            Покупает с {date} г.
          </div>
        )}
        <div className='flex items-center text-[var(--ultra-dark-grey)] group-hover:text-[var(--dark-red)]'>
          <Picture
            pictureClassName={'mr-1'}
            icon={speechBalloon}
            width='14'
            height='14'
          />{' '}
          {comments}
        </div>
        <div
          className={twcls(
            'absolute z-50 hidden pt-1 top-5 sm:max-w-[18rem] sm:w-72 group-hover:block',
            tooltipAlignRight ? 'right-0' : '-left-4'
          )}
        >
          <div
            className={twcls(
              `
          sm:w-full
          px-4
          py-6
          transition-visibility
          duration-200
          bg-white
          rounded-lg
          transform-gpu
          backdrop-blur-0
          drop-shadow-main
          z-10
          w-[21rem]
          after:content-['']
          after:absolute
          after:-top-1.5
          after:w-3
          after:h-3
          after:rotate-45
          after:-z-10
          after:bg-white
          `,
              tooltipAlignRight ? 'after:right-4' : 'after:left-4'
            )}
          >
            <div className='flex'>
              <div className='mr-3 overflow-hidden rounded-full w-11 h-11 min-w-[2.75rem] '>
                <img
                  src={
                    peopleItem.attachmentsItem?.cacheItem?.[0]?.filePath ||
                    userNoAvatar
                  }
                  className='object-contain w-full h-full'
                  alt={peopleItem.fio || 'Клиент'}
                />
              </div>
              <div className=''>
                <div className='font-bold mb-2.5'>{peopleItem.fio}</div>
                {!!peopleItem?.date && (
                  <div className='flex items-center mb-4'>
                    <Picture
                      pictureClassName={'mr-1'}
                      icon={star2}
                      width='14'
                      height='14'
                    />{' '}
                    Покупает с {date} года
                  </div>
                )}
                <div className='flex items-center mb-4'>
                  <Picture
                    pictureClassName={'mr-1'}
                    icon={speechBalloon}
                    width='14'
                    height='14'
                  />{' '}
                  {comments}
                </div>
                <div className='text-sm text-[var(--ultra-dark-grey)] '>
                  {peopleItem?.favoriteRubric?.affiliate_title ||
                    peopleItem?.favoriteRubric?.title}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(ClientReviewStats);
